import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import firebase from 'firebase'
import db from '../services/firebase'
import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userfirstname: null,
    userlastname: null,
    useremail: null,
    usercolor: null,
    userlevel: null,
    userTwilioAccountSID: null,
    teamTwilioAccountSID: null,
    teamTwilioAuthToken: null,
    teamTwilioSMSNumber: null,
    teamname: null,
    teamlastupdate: null,
    selectedcontactSMS: null,
    globalcontacthistory: null,
    forceConversationUpdate: null
  },
  actions: {
    getContactHistory (context) {
      var endpoint = 'https://api.cvstech.com/twilio/contacthistory/'
      console.log('Getting Contact History...')
      console.log(context.state.teamTwilioSMSNumber)
      if (context.state.teamTwilioSMSNumber) {
        axios.post(endpoint + context.state.teamTwilioSMSNumber, {sid: context.state.teamTwilioAccountSID, token: context.state.teamTwilioAuthToken})
          .then(response => {
            context.state.globalcontacthistory = response.data
            // console.log(context.state.globalcontacthistory)
            if (!context.state.selectedcontactSMS) {
              context.state.selectedcontactSMS = context.state.globalcontacthistory[1].contactnumber
              setTimeout(context.state.selectedcontactSMS = context.state.globalcontacthistory[0].contactnumber, 150)
            }
            context.dispatch('getCallerIDnames')
          })
          .catch(error => {
            console.log('----- getContactHistory error-------')
            console.log(error)
            console.log('----- getContactHistory error-------')
          })
        console.log('setting up snapshot for ' + context.state.teamTwilioAccountSID)
        db.collection('teams').doc(context.state.teamTwilioAccountSID).collection('contacts')
          .onSnapshot(function (snapshot) {
            console.log('update to contacts detected...')
            snapshot.forEach(function (doc) {
              for (var i = 0; i < context.state.globalcontacthistory.length; i++) {
                if (context.state.globalcontacthistory[i]['contactnumber'] === doc.id) {
                  Vue.set(context.state.globalcontacthistory[i], name, doc.data().name)
                  console.log(context.state.globalcontacthistory[i].name)
                }
              }
            })
          })
      } else {
        console.log('Not ready. Wait 250ms...')
        setTimeout(store.dispatch('getContactHistory'), 250)
      }
    },
    getCallerIDnames (context, payload) {
      console.log('getting caller id names')
      context.state.globalcontacthistory.forEach((contact) => {
        db.collection('teams')
          .doc(context.state.teamTwilioAccountSID)
          .collection('contacts')
          .doc(contact.contactnumber)
          .get()
          .then(function (doc) {
            if (doc.id) {
              if (doc.data().name === null) {
                console.log('getCallerIDnames -- doc.data().name === null')
                console.log(doc.id)
                console.log(doc.data())
                console.log('getCallerIDnames -- doc.data().name === null')
                store.dispatch('updatecontactRecord', { contactnumber: doc.id, data: doc })
              } else {
                for (var i = 0; i < context.state.globalcontacthistory.length; i++) {
                  if (context.state.globalcontacthistory[i].contactnumber === contact.contactnumber) {
                    Vue.set(context.state.globalcontacthistory[i], 'name', doc.data().name)
                    if (doc.data().lastviewed) {
                      Vue.set(context.state.globalcontacthistory[i], 'lastviewed', doc.data().lastviewed)
                    } else {
                      Vue.set(context.state.globalcontacthistory[i], 'lastviewed', 1000000000)
                    }
                  }
                }
              }
            } else {
              console.log('No doc.id')
            }
          })
      })
    },
    updatecontactRecord (context, payload) {
      var number = payload.contactnumber
      var lookupendpoint = 'https://api.cvstech.com/twilio/lookup/'
      console.log('===--- ' + payload.data.id + ' ---===')
      console.log(payload)
      if (payload.data.id) {
        axios.post(lookupendpoint + number, {sid: context.state.teamTwilioAccountSID, token: context.state.teamTwilioAuthToken})
          .then(response => {
            var newname = ''
            if (payload.data.name) {
              newname = payload.data.name
            }
            console.log('saving ' + newname + ' to ' + number)
            db.collection('teams')
              .doc(context.state.teamTwilioAccountSID)
              .collection('contacts')
              .doc(number)
              .update({ name: newname })
            for (var i = 0; i < context.state.globalcontacthistory.length; i++) {
              if (context.state.globalcontacthistory[i].contactnumber === number) {
                Vue.set(context.state.globalcontacthistory[i], name, newname)
              }
            }
          })
      }
    }
  },
  mutations: {
    updateField
  },
  getters: {
    getField
  },
  modules: {

  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js